/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { baseAuthHeaders } from "#/modules/auth/idp";

type PatchMePreferencesResponse = {
  default_customer_id: string | null;
  default_license_id: string | null;
};

// PATCH /xecguard/internal/v1/me/preferences — persist the caller's default Organization.
// Internal-Admin plane: BearerAuth only. Pass null to clear; omit a key to leave unchanged.
// Mirrors xcockpit's "Set as Homepage Organization" (patchFocusCustomer) — setting the
// default is a separate action from switching the active org for this session.
export default function patchMePreferences(
  { token, defaultLicenseId }: { token: string; defaultLicenseId: string | null },
): Promise<InternalResponse<PatchMePreferencesResponse>> {
  return request()({
    url: "/xecguard/internal/v1/me/preferences",
    method: "PATCH",
    headers: baseAuthHeaders(token),
    data: { default_license_id: defaultLicenseId },
  }).then(
    (result: AxiosResponse<PatchMePreferencesResponse>): InternalResponse<PatchMePreferencesResponse> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.response?.status ?? error.code,
    msg: error.message,
    success: false,
  }));
}
